// extracted by mini-css-extract-plugin
export default {"container":"home_container__rnSMt","main":"home_main__nqGdX","title":"home_title__f9Cp8","buttonContainer":"home_buttonContainer__8IIMW","Button":"home_Button__3Gz1K"};